module.exports = __webpack_public_path__ + "img/27.b7105222.png";